export const LX_FORM_CONTENT = `<h4>一、项目详情</h4>
<h4 style="text-indent: 2em">1.项目发起事由</h4>
<p  style="text-indent: 2em">简要描述发起项目的原因，也可以介绍发起项目时的背景，可以附上项目实施地的图片。</p>
<p  style="text-indent: 2em">清楚地阐明，为什么发起这次筹款，以及为谁而筹款？建议以故事的形式切入，图文并茂的讲述受助者最打动你的细节，一句话，一个举动，一件事，如果是群体救助，可以选择1-3个有代表性的个案故事来描述。</p>
<h4 style="text-indent: 2em">2.受助人群介绍</h4>
<p  style="text-indent: 2em">介绍受助人特点、目前遇到的困难、受助人数量，可以附上受助人图片；说清楚受助人/群体遇到的真实困难，建议100-300字，图文并茂</p>
<h4 style="text-indent: 2em">3.项目目标</h4>
<p  style="text-indent: 2em">简要描述发起项目的原因，也可以介绍发起项目时的背景，可以附上项目实施地的图片。</p>
<h4>二、项目预算</h4>
<h4 style="text-indent: 2em">1.项目预算表</h4>
<h4 style="text-indent: 2em">2.项目最低执行金额</h4>
<p  style="text-indent: 2em">筹款金额达到多少就可以执行项目，如果未达到最低执行金额，善款将如何处理。</p>
<h4 style="text-indent: 2em">3.剩余善款处理计划</h4>
<p  style="text-indent: 2em">若项目执行完成后善款仍有剩余，剩余善款要如何处理。</p>
<h4 style="text-indent: 2em">4.项目开始募捐时间</h4>
<h4>三、项目执行计划</h4>
<p>若项目执行完成后善款仍有剩余，剩余善款要如何处理。</p>
<h4>四、票据说明</h4>
<p>若项目执行完成后善款仍有剩余，剩余善款要如何处理。</p>
`
